import { SEARCH_EVENT_TYPE } from '../../../common/search/search.constants';
import { storageKeys } from '../../../utils/browser-storage/storage-keys';
import qualityEventsHelpers from '../quality-events.helpers';

export const HOME_PAGE_QUALITY_EVENTS = {
    heroMaterials() {
        qualityEventsHelpers.track({
            extra: JSON.stringify(Date.now()),
            type: 'HeroMaterials',
            user_id: window.storage.getItem(storageKeys.user.userId)
        });
    },
    heroHandover(source: string) {
        qualityEventsHelpers.track({ type: SEARCH_EVENT_TYPE.HANDOVER_HERO_HEADER, source }).then();
    }
};
